import { FC } from 'react'

import styled from 'styled-components'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { SpotifyCampaignAiUsageEnum } from 'src/Types/campaigns'
import { ModalType, ScheduleSteps } from 'src/Types/ui'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { AddParameterButton } from 'src/Components/Buttons/AddParameterButton'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`
const SubTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const AiUsageValue = styled(SubTitle)`
  font-weight: 400;
`

const AI_USAGE_LABEL: { [key in SpotifyCampaignAiUsageEnum]: string } = {
  [SpotifyCampaignAiUsageEnum.NONE]: 'No AI used',
  [SpotifyCampaignAiUsageEnum.ASSISTED]: 'AI-assisted',
  [SpotifyCampaignAiUsageEnum.GENERATED]: 'AI-generated',
}

interface ScheduleAiUsageProps {
  aiUsage: SpotifyCampaignAiUsageEnum | null
}

export const SpotifyScheduleAiUsage: FC<ScheduleAiUsageProps> = ({
  aiUsage,
}) => {
  const { setSearch } = useCustomSearchParams()

  const handleClick = (): void => {
    const query = {
      step: ScheduleSteps.SETTINGS,
      modal: ModalType.AiUsage,
    }
    setSearch(query)
  }

  if (!aiUsage) {
    return (
      <AddParameterButton onClick={handleClick}>
        Add AI usage info
      </AddParameterButton>
    )
  }

  return (
    <Container>
      <Wrapper>
        <SubTitle>AI usage</SubTitle>
        <AiUsageValue>{AI_USAGE_LABEL[aiUsage]}</AiUsageValue>
      </Wrapper>
      <PrimaryDottedButton onClick={handleClick}>Edit</PrimaryDottedButton>
    </Container>
  )
}
